module.exports = __webpack_public_path__ + "static/media/stepsImage.133f954c.jpg";